import { render } from "./WithdrawModal.vue?vue&type=template&id=e266000c&scoped=true"
import script from "./WithdrawModal.vue?vue&type=script&lang=js"
export * from "./WithdrawModal.vue?vue&type=script&lang=js"

import "./WithdrawModal.vue?vue&type=style&index=0&id=e266000c&lang=scss&scoped=true"

import exportComponent from "D:\\由创科技-ljx\\apicode\\github\\DY.Web\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e266000c"]])

export default __exports__